import axios from "axios";
import { __constants } from "../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const getPrivacyPolicyController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/privacy-policy",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getPrivacyPolicyController >> ", err.message);
        return err.response
    }
}

export const getCancelPolicyController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/cancel-policy",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getPrivacyPolicyController >> ", err.message);
        return err.response
    }
}

export const getTermsAndConditionsController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/term-conditions",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getTermsConditionsController >> ", err.message);
        return err.response
    }
}

export const getDisclaimerController = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/disclaimer",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getDisclaimerController >> ", err.message);
        return err.response
    }
}

export const addlegalDocumentController = async (data) => {
    try {
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/privacy-pages",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addlegalDocumentController >> ", err.message);
        return err.response
    }
}
